export const PRICE_DROP_PROTECTION_TITLE = "Free Price Drop Protection";
export const PRICE_DROP_PROTECTION_SUBTITLE = "Terms and Conditions";
export const PRICE_DROP_PROTECTION_BODY = "Pending";
